export const SET_ACTIVE_TAB = 'SET_ACTIVE_TAB';

export const ActiveTabSet = (tab:any) => ({
    type: SET_ACTIVE_TAB,
    payload: tab,
  });
  